<template>
    <transition  >
    <div class="container-fluid page-content">
        <!-- Modern Page Header -->
        <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center page-header-row gap-3">
            <div>
                <h4 class="page-title text-slate-800 fw-bold mb-1">Role List</h4>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0">
                        <li class="breadcrumb-item"><a href="/" class="text-muted"><i class="fas fa-home me-1"></i>Home</a></li>
                        <li class="breadcrumb-item"><a href="javascript:void(0);" class="text-muted">User Settings</a></li>
                        <li class="breadcrumb-item active text-indigo fw-medium" aria-current="page">Roles</li>
                    </ol>
                </nav>
            </div>
            <div>
                <button type="button" class="btn btn-premium d-flex align-items-center gap-2" @click="toggleModal()" v-if="permission['role-create']">
                    <i class="fas fa-plus"></i> Create New
                </button>
            </div>
        </div>
        
        <!-- Modern Filter Dashboard Bar -->
        <div class="card border-0 shadow-sm filter-card" v-if="items.length > 0 || search">
            <div class="card-body p-3">
                <div class="row align-items-center g-2 justify-content-end">
                    <div class="col-md-4 col-sm-6">
                        <div class="position-relative search-container ms-auto">
                            <i class="fas fa-search search-icon text-muted"></i>
                            <input type="text" class="form-control-custom search-input" v-model="search" placeholder="Search roles...">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modern Add/Edit Modal -->
        <Modal @close="toggleModal()" :modalActive="modalActive">
            <div class="modal-content border-0 shadow-lg modal-premium">
                <div class="modal-header"> 
                    <h4 class="fw-bold m-0">{{ editMode ? 'Update Role' : 'Create New Role' }}</h4>
                    <button @click="toggleModal()" type="button" class="btn-close-custom">✕</button>
                </div>
                <form @submit.prevent="submitForm()" enctype="multipart/form-data" >
                    <div class="modal-body py-4">
                        <div class="row g-3">
                            <div class="col-md-12">
                                <div class="form-group mb-0">
                                    <label for="name" class="form-label-custom text-slate-700 fw-semibold mb-2">Role Name *</label>
                                    <input type="text" class="form-control-custom" :class="{'is-invalid': errors.name}" @keypress="onkeyPress('name')" v-model="form.name" id="name" placeholder="Enter role name" autocomplete="off"> 
                                    <div class="invalid-feedback" v-if="errors.name">
                                        {{errors.name[0]}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12 mt-3">
                                <div class="form-group mb-0">
                                    <label for="description" class="form-label-custom text-slate-700 fw-semibold mb-2">Description</label>
                                    <textarea class="form-control-custom form-textarea" :class="{'is-invalid': errors.description}" @keypress="onkeyPress('description')" v-model="form.description" id="description" placeholder="Describe the role..." rows="3"></textarea>
                                    <div class="invalid-feedback" v-if="errors.description">
                                        {{errors.description[0]}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer border-0 pt-0">
                        <button type="button" class="btn btn-outline-premium me-2" @click="toggleModal()">Cancel</button>
                        <button type="submit" class="btn btn-premium" :disabled="disabled">
                            <span v-show="isSubmit" class="spinner-border spinner-border-sm me-2" role="status"></span>
                            {{btn}} Role
                        </button>
                    </div>
                </form>
            </div>
        </Modal>

        <!-- Modern Table List Card -->
        <div class="card border-0 shadow-sm table-card">
            <div class="card-body p-0">   
                <div class="table-responsive">
                    <table class="table table-premium mb-0" v-if="!loading && filteredItems.length > 0">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 10%;">SL</th>
                                <th class="text-start" style="width: 40%;">Role Name</th>
                                <th class="text-start" style="width: 40%;">Description</th>
                                <th class="text-center" style="width: 10%;">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in filteredItems" :key="i">
                                <td class="text-center text-muted fw-semibold">{{ i + 1 }}</td>
                                <td class="text-start">
                                    <span class="fw-bold text-slate-800">{{ item.name }}</span>
                                </td>
                                <td class="text-start text-muted">
                                    {{ item.description || '—' }}
                                </td>
                                <td class="text-center">
                                    <div class="dropdown">
                                        <button class="btn btn-icon" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end border-0 shadow-lg dropdown-premium"> 
                                            <li v-if="permission['role-permission']">
                                                <a href="#" @click="changePermission(item.id)" title="Change Permission" class="text-primary dropdown-item changePermission">
                                                    <i class="fas fa-shield-alt me-2"></i> Permission
                                                </a>
                                            </li>
                                            <li v-if="permission['role-permission'] && (permission['role-edit'] || permission['role-delete'])"><hr class="dropdown-divider"></li>
                                            <li v-if="permission['role-edit']">
                                                <a href="javascript:void(0);" class="dropdown-item text-warning" @click="edit(item)">
                                                    <i class="fas fa-edit me-2"></i> Edit
                                                </a> 
                                            </li>
                                            <li v-if="permission['role-edit'] && permission['role-delete']"><hr class="dropdown-divider"></li>
                                            <li v-if="permission['role-delete']">
                                                <a href="javascript:void(0);" class="dropdown-item text-danger" @click.prevent="deleteItem(item)">
                                                    <i class="fas fa-trash-alt me-2"></i> Remove
                                                </a>
                                            </li>
                                        </ul>
                                    </div>  
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- Fallback State -->
                    <div v-if="!loading && filteredItems.length === 0" class="text-center py-5">
                        <img src="../../assets/image/loading.gif" class="mb-3 opacity-25" style="width: 80px; filter: grayscale(1);" />
                        <h5 class="text-muted fw-semibold">No Roles Found</h5>
                        <p class="text-muted mb-0 small">Try adjusting your search keywords.</p>
                    </div>

                    <!-- Loading State -->
                    <div v-if="loading" class="text-center py-5">
                        <div class="spinner-premium mb-3"></div>
                        <h5 class="text-muted fw-semibold">Loading Roles</h5>
                        <p class="text-muted mb-0 small">Please wait a moment...</p>
                    </div>
                </div>
            </div> 
        </div>
    </div>
    </transition>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import { useCartStore } from '@/stores/cart';
import { useProductStore } from '@/stores/product';
import { useRequisitionProductStore } from '@/stores/requisitionProduct';


import Modal from "./../helper/Modal.vue";
import { ref, onMounted, getCurrentInstance } from "vue";
import Form from "vform";
import axios from "axios";
import RolePermission from "@/views/page/RolePermission.vue";  
export default {
    name: "PosLeftbar",
    components: {
        Modal,
        RolePermission
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode: false,
            disabled: false,
            modalActive: false,
            errors: {},
            btn:'Create',
            items: [],
            search: '',
            form: new Form({
                id: '',
                name: '',
                description: '',
                // status: 1,
            }),
        }
    },
    created() {
        this.fetchRoleData();
    },

    methods: {
        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset();  
        },
        fetchRoleData() { 
            axios.get(this.apiUrl+'/roles', this.headerjson)
            .then((res) => {
                this.items = res.data.data;
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        edit: function(item) {
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            this.form.fill(item); 
        },
        submitForm: function(e) { 
            
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();  
            formData.append('name', this.form.name);
            formData.append('description', this.form.description);
            if(this.editMode){
                formData.append('_method', 'put');
                var postEvent = axios.post(this.apiUrl+'/roles/'+this.form.id, formData, this.headers);
            }else{
                var postEvent = axios.post(this.apiUrl+'/roles', formData, this.headers);
            }           

            postEvent.then(res => {
                
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.toggleModal();
                    this.fetchRoleData();
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                }
            }).catch(err => {  
                this.isSubmit = false;
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            })
        },

        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        deleteItem: function(item) { 
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this item!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/roles/'+item.id, this.headers)
                    .then(res => {
                        if(res.status == 200){ 
                            this.fetchRoleData();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        } 
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message);
                        if(err.response.status == 422){
                            this.errors = err.response.data.errors 
                        }
                    }) 
                }
            }); 
        },

        changePermission(role_id){
            this.$router.push({name: 'role-permission', params:{id:role_id}});
        }
    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {
        permission() {
            let pname = this.$route.meta.parent_module;
            let module_name = this.$route.meta.module_name;
            let path_name = this.$route.path; 
            let data = '';
            if(this.$route.meta.parent_module){
                data = this.$store.getters.userAllPermissions[pname][0].children[path_name]
            }else{
                data = this.$store.getters.userAllPermissions[module_name][0].other_actions; 
            } 
            return data;
        },
        filteredItems() {
            if (!this.search) {
                return this.items;
            }
            const query = this.search.toLowerCase();
            return this.items.filter(item => {
                return (
                    (item.name && item.name.toLowerCase().includes(query)) ||
                    (item.description && item.description.toLowerCase().includes(query))
                );
            });
        }
    }
}
</script>

<style scoped>
</style>